import { useWorkflow as useWorkflowV6 } from '../components/v6/operations/settings/form/contexts/WorkflowContext';
import { usePresetContext } from '../components/v7/contexts/PresetContext';
import { isRpdx7 } from '../utils/isRpdx7';

export const useWorkflow = () => {
  const {
    workflow: { rpdxVersion: rpdxVersionFromContextForLegacy },
    getWorkflow: getWorkflowV6,
    updateWorkflowAttributes: updateWorkflowAttributesV6,
    resetWorkflow: resetWorkflowV6,
  } = useWorkflowV6();
  const {
    workflow: { rpdxVersion },
    getWorkflow: getWorkflowV7,
    updateWorkflowAttributes: updateWorkflowAttributesV7,
    clearChangesInForm: resetWorkflowV7,
  } = usePresetContext();

  if (rpdxVersionFromContextForLegacy !== rpdxVersion) {
    throw new Error('rpdxVersion mismatch'); //Should never happen, as both workflows get the same workflow object. If ever happens, it means, we've changed how those contexts work and we need to adjust this hook accordingly
  }

  const isRpdx7Workflow = isRpdx7(rpdxVersion);

  return {
    getWorkflow: isRpdx7Workflow ? getWorkflowV7 : getWorkflowV6,
    updateWorkflowAttributes: isRpdx7Workflow ? updateWorkflowAttributesV7 : updateWorkflowAttributesV6,
    resetWorkflow: isRpdx7Workflow ? resetWorkflowV7 : resetWorkflowV6,
  };
};
